import {
	Icon,
	Row,
} from 'native-base';
import CommentDots from '@onehat/ui/src/Components/Icons/CommentDots.js';
import _ from 'lodash';


export default function ConnectionStatus(props) {

	return <Row
				h="30px"
				w="100%"
				alignItems="center"
				justifyContent="flex-start"
				pl={2}
				pt={6}
				pb={8}
			>
				<Icon
					as={CommentDots}
					color="muted.200"
					size={10}
				/>
			</Row>;
}
